import React, { useState } from 'react';
import Button from 'components/atoms/Button';
import Loader from 'components/molecules/Loader';
import { CustomModalForSave } from 'components/pages/PromoRecommendation';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED } from 'utils/mixpanelEventNames';
import LinkPricingSimulator from './LinkPricingSimulator';

interface props {
    setSaveScenario: Function;
    onSave: Function;
    saveScenario: any;
    loading?: boolean;
    error?: string;
    title?: string;
    setError?: Function;
    selectedSimulationKey: any[];
    setSelectedSimulationKeys: Function;
    allScenariosData: any[];
}

function SaveScenarioModal({
    setError,
    setSaveScenario,
    saveScenario,
    onSave,
    loading,
    error,
    title,
    selectedSimulationKey,
    setSelectedSimulationKeys,
    allScenariosData,
}: props) {
    const [text, setText] = useState('');
    const handleOk = () => {
        setSaveScenario(false);
    };

    const handleCancel = () => {
        setSaveScenario(false);
    };

    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                <Button title={'Cancel'} onClick={() => setSaveScenario(false)} style={{ padding: '0px 20px' }} />
                <Button
                    title={'Save'}
                    onClick={() => {
                        if (!text.trim()) return;
                        onSave({ text: text });
                    }}
                    theme={'Solid'}
                    style={{ padding: '0px 20px' }}
                />
            </div>
        );
    };

    return (
        <>
            {loading && (
                <div className="fixed inset-0 bg-[#edf0f3] z-[1001] opacity-60">
                    <Loader />
                </div>
            )}
            <CustomModalForSave
                afterClose={() => {
                    setText('');
                    if (setError) setError(null);
                }}
                destroyOnClose
                title={title}
                open={saveScenario}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                width={600}
                footer={Footer()}
            >
                <div className="flex w-full flex-col -mt-4">
                    <div className="flex w-full justify-start items-start gap-2 flex-col">
                        <div className="w-full flex gap-2 justify-start items-center">
                            <span className="font-xs font-medium">Plan Name</span>
                            <input
                                className="m-0.5 pl-2 py-1 focus:outline-none w-1/2 rounded border border-purpleFont"
                                onChange={(e) => {
                                    setText(e.target.value);
                                    trackEventMixpanel(PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED, {
                                        name: e.target.value,
                                    });
                                }}
                                value={text}
                                placeholder="Enter Name"
                            />
                        </div>
                        {error && <p className="text-redTriangle font-xxs font-medium">{error}</p>}
                    </div>

                    <LinkPricingSimulator
                        selectedSimulationKey={selectedSimulationKey}
                        setSelectedSimulationKeys={setSelectedSimulationKeys}
                        allScenariosData={allScenariosData}
                    />
                </div>
            </CustomModalForSave>
        </>
    );
}

export default SaveScenarioModal;
